module.exports = __webpack_public_path__ + "static/media/karolin.d66a4260.png";